import styled from "styled-components";

const CustomLabelDim = styled.div`
  color: var(--elementDim);
  font-size: 15px;
  font-weight: 600;
  opacity: 0.7;
  text-transform: capitalize;
`;

export default CustomLabelDim;
